import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import Link from "next/link";
import Router from "next/router";
import { Badge, Col, Collapse, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, Navbar, NavbarToggler, NavItem, NavLink, Row } from "reactstrap";
import UseWindowSize from "../hooks/UseWindowSize";
import ActiveLink from "./ActiveLink";
import menu from "../data/menu.json";
import userMenu from "../data/user-menu.json";
import Image from "./CustomImage";
import Icon from "./Icon";
import { getImageUrl } from "../services/image";
import dynamic from "next/dynamic";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SearchBox = dynamic(function () {
  return import("./Header/SearchBox");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./Header/SearchBox")];
    },
    modules: ["../components/Header.js -> " + "./Header/SearchBox"]
  }
});
var SearchBar = dynamic(function () {
  return import("./CottageSearch/SearchBar");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./CottageSearch/SearchBar")];
    },
    modules: ["../components/Header.js -> " + "./CottageSearch/SearchBar"]
  }
});
var CartMenuItem = dynamic(function () {
  return import("./MainMenu/CartMenuItem");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./MainMenu/CartMenuItem")];
    },
    modules: ["../components/Header.js -> " + "./MainMenu/CartMenuItem"]
  }
});
var FavouriteMenuItem = dynamic(function () {
  return import("./MainMenu/FavouriteMenuItem");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./MainMenu/FavouriteMenuItem")];
    },
    modules: ["../components/Header.js -> " + "./MainMenu/FavouriteMenuItem"]
  }
});

var Header = function Header(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      collapsed = _React$useState2[0],
      setCollapsed = _React$useState2[1];

  var _React$useState3 = React.useState({}),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      dropdownOpen = _React$useState4[0],
      setDropdownOpen = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      dropdownAnimate = _React$useState6[0],
      setDropdownAnimate = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      parentName = _React$useState8[0],
      setParentName = _React$useState8[1];

  var size = UseWindowSize();

  var toggleDropdown = function toggleDropdown(name) {
    setDropdownOpen(_objectSpread(_objectSpread({}, dropdownOpen), {}, _defineProperty({}, name, !dropdownOpen[name])));
  };

  var onLinkClick = function onLinkClick(parent) {
    size.width < 991 && setCollapsed(!collapsed);
    setParentName(parent);
  }; // highlight not only active dropdown item, but also its parent, i.e. dropdown toggle


  var highlightDropdownParent = function highlightDropdownParent() {
    menu.map(function (item) {
      item.dropdown && item.dropdown.map(function (dropdownLink) {
        dropdownLink.link && dropdownLink.link === Router.route && setParentName(item.title);
        dropdownLink.links && dropdownLink.links.map(function (link) {
          return link.link === Router.route && setParentName(item.title);
        });
      });
      item.megamenu && item.megamenu.map(function (megamenuColumn) {
        return megamenuColumn.map(function (megamenuBlock) {
          return megamenuBlock.links.map(function (dropdownLink) {
            if (dropdownLink.link === Router.route) {
              dropdownLink.parent ? setParentName(dropdownLink.parent) : setParentName(item.title);
            }
          });
        });
      });
      item.link === Router.route && setParentName(item.title);
    });
  };

  React.useEffect(highlightDropdownParent, []);
  return /*#__PURE__*/_jsx("header", {
    className: "header ".concat(props.headerClasses ? props.headerClasses : ""),
    children: /*#__PURE__*/_jsx(Navbar, {
      color: props.nav.color ? props.nav.color : "white",
      light: props.nav.light && true,
      dark: props.nav.dark && true,
      fixed: props.nav.fixed ? props.nav.fixed : "top",
      expand: "lg",
      className: props.nav.classes ? props.nav.classes : "",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex-column w-100",
        children: [/*#__PURE__*/_jsxs(Container, {
          fluid: true,
          children: [/*#__PURE__*/_jsxs("div", {
            className: "d-flex align-items-center",
            children: [/*#__PURE__*/_jsx(Link, {
              href: "/",
              passHref: true,
              children: /*#__PURE__*/_jsx("a", {
                className: "py-1 navbar-brand",
                children: /*#__PURE__*/_jsx("img", {
                  src: "/logo.png",
                  width: "138",
                  height: "31",
                  alt: "Cottage Centre logo"
                })
              })
            }), /*#__PURE__*/_jsx(SearchBox, {})]
          }), /*#__PURE__*/_jsx(NavbarToggler, {
            onClick: function onClick() {
              return setCollapsed(!collapsed);
            },
            className: "navbar-toggler-right",
            children: /*#__PURE__*/_jsx("i", {
              className: "fa fa-bars"
            })
          }), /*#__PURE__*/_jsx(Collapse, {
            isOpen: collapsed,
            navbar: true,
            children: /*#__PURE__*/_jsxs(Nav, {
              navbar: true,
              className: "ml-auto",
              children: [menu && menu.map(function (item) {
                return item.dropdown || item.megamenu ? // show entire menu to unlogged user or hide items that have hideToLoggedUser set to true
                !props.loggedUser || props.loggedUser && !item.hideToLoggedUser ? /*#__PURE__*/_jsxs(Dropdown, {
                  nav: true,
                  inNavbar: true,
                  className: item.position ? "position-".concat(item.position) : "",
                  isOpen: dropdownOpen[item.title],
                  toggle: function toggle() {
                    return toggleDropdown(item.title);
                  },
                  children: [/*#__PURE__*/_jsx(DropdownToggle, {
                    nav: true,
                    caret: true,
                    onClick: function onClick() {
                      return setDropdownAnimate(_objectSpread(_objectSpread({}, dropdownAnimate), {}, _defineProperty({}, item.title, !dropdownOpen[item.title])));
                    },
                    className: parentName === item.title ? "active" : "",
                    children: item.title
                  }), /*#__PURE__*/_jsxs(DropdownMenu, {
                    className: "".concat(dropdownAnimate[item.title] === false ? "hide" : "", " ").concat(item.megamenu ? "megamenu py-lg-0" : ""),
                    children: [item.dropdown && item.dropdown.map(function (dropdownItem) {
                      return dropdownItem.links ? /*#__PURE__*/_jsxs(React.Fragment, {
                        children: [/*#__PURE__*/_jsx("h6", {
                          className: "dropdown-header font-weight-normal",
                          children: dropdownItem.title
                        }), dropdownItem.links.map(function (link) {
                          return /*#__PURE__*/_jsx(ActiveLink, {
                            activeClassName: "active",
                            href: link.link,
                            passHref: true,
                            children: /*#__PURE__*/_jsxs(DropdownItem, {
                              onClick: function onClick() {
                                return onLinkClick(item.title);
                              },
                              children: [link.title, link.new && /*#__PURE__*/_jsx(Badge, {
                                color: "info-light",
                                className: "ml-1 mt-n1",
                                children: "New"
                              })]
                            })
                          }, link.title);
                        })]
                      }, dropdownItem.title) : /*#__PURE__*/_jsx(ActiveLink, {
                        activeClassName: "active",
                        href: dropdownItem.link,
                        passHref: true,
                        children: /*#__PURE__*/_jsxs(DropdownItem, {
                          onClick: function onClick() {
                            return onLinkClick(item.title);
                          },
                          children: [dropdownItem.title, dropdownItem.new && /*#__PURE__*/_jsx(Badge, {
                            color: "info-light",
                            className: "ml-1 mt-n1",
                            children: "New"
                          })]
                        })
                      }, dropdownItem.title);
                    }), item.megamenu && /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsxs(Col, {
                        lg: "9",
                        children: [/*#__PURE__*/_jsx(Row, {
                          className: "p-3 pr-lg-0 pl-lg-5 pt-lg-5",
                          children: item.megamenu.map(function (megamenuItem, index) {
                            return /*#__PURE__*/_jsx(React.Fragment, {
                              children: megamenuItem.map(function (block, index) {
                                return /*#__PURE__*/_jsxs(Col, {
                                  lg: block.size ? block.size : 3,
                                  children: [/*#__PURE__*/_jsx("h6", {
                                    className: "text-uppercase",
                                    children: block.title
                                  }), /*#__PURE__*/_jsx("ul", {
                                    className: "megamenu-list list-unstyled",
                                    children: block.links.map(function (link) {
                                      return /*#__PURE__*/_jsx("li", {
                                        className: "megamenu-list-item",
                                        children: /*#__PURE__*/_jsx(ActiveLink, {
                                          activeClassName: "active",
                                          href: link.link,
                                          as: link.as,
                                          passHref: true,
                                          children: /*#__PURE__*/_jsxs(DropdownItem, {
                                            className: "megamenu-list-link",
                                            onClick: function onClick() {
                                              return link.parent ? onLinkClick(link.parent) : onLinkClick(item.title);
                                            },
                                            children: [link.title, link.new && /*#__PURE__*/_jsx(Badge, {
                                              color: "info-light",
                                              className: "ml-1 mt-n1",
                                              children: "New"
                                            })]
                                          })
                                        })
                                      }, link.title);
                                    })
                                  })]
                                }, index);
                              })
                            }, index);
                          })
                        }), item.services && /*#__PURE__*/_jsx(Row, {
                          className: "megamenu-services d-none d-lg-flex pl-lg-5",
                          children: item.services.map(function (service) {
                            return /*#__PURE__*/_jsx(Col, {
                              xl: "3",
                              lg: "6",
                              className: "d-flex",
                              children: /*#__PURE__*/_jsxs("div", {
                                className: "megamenu-services-item",
                                children: [/*#__PURE__*/_jsx(Icon, {
                                  icon: service.icon,
                                  className: "megamenu-services-icon"
                                }), /*#__PURE__*/_jsxs("div", {
                                  children: [/*#__PURE__*/_jsx("h6", {
                                    className: "text-uppercase",
                                    children: service.title
                                  }), /*#__PURE__*/_jsx("p", {
                                    className: "mb-0 text-muted text-sm",
                                    children: service.content
                                  })]
                                })]
                              })
                            }, service.title);
                          })
                        }), item.logos && /*#__PURE__*/_jsx(Row, {
                          className: "megamenu-services megamenu-logos d-none d-lg-flex pl-lg-5",
                          children: item.logos.map(function (logo) {
                            return /*#__PURE__*/_jsx(Col, {
                              xl: "3",
                              lg: "6",
                              className: "d-flex",
                              children: /*#__PURE__*/_jsx("div", {
                                className: "megamenu-services-item",
                                children: /*#__PURE__*/_jsx(Link, {
                                  href: logo.link,
                                  passHref: true,
                                  children: /*#__PURE__*/_jsx("a", {
                                    children: /*#__PURE__*/_jsx(Image, {
                                      src: getImageUrl(logo.image),
                                      className: "bg-image",
                                      height: logo.height,
                                      width: logo.width,
                                      alt: logo.title
                                    })
                                  })
                                })
                              })
                            }, logo.image);
                          })
                        })]
                      }), item.image && /*#__PURE__*/_jsx(Col, {
                        lg: "3",
                        className: "d-none d-lg-block",
                        children: /*#__PURE__*/_jsx(Image, {
                          src: getImageUrl(item.image),
                          alt: "",
                          className: "bg-image",
                          layout: "fill"
                        })
                      })]
                    })]
                  })]
                }, item.title) : "" : props.loggedUser && !item.hideToLoggedUser || !props.loggedUser ? /*#__PURE__*/_jsx(NavItem, {
                  className: item.button ? "mt-3 mt-lg-0 ml-lg-3 d-lg-none d-xl-inline-block" : "",
                  children: item.button ? item.showToLoggedUser !== false && /*#__PURE__*/_jsx(ActiveLink, {
                    activeClassName: "active",
                    href: item.link,
                    children: /*#__PURE__*/_jsx("a", {
                      className: "btn btn-primary",
                      onClick: function onClick() {
                        return onLinkClick(item.title);
                      },
                      children: item.title
                    })
                  }) : /*#__PURE__*/_jsx(ActiveLink, {
                    activeClassName: "active",
                    href: item.link,
                    passHref: true,
                    children: /*#__PURE__*/_jsx(NavLink, {
                      onClick: function onClick() {
                        return onLinkClick(item.title);
                      },
                      children: item.title
                    })
                  })
                }, item.title) : "";
              }), props.loggedUser && userMenu && userMenu.map(function (item) {
                return /*#__PURE__*/_jsxs(Dropdown, {
                  nav: true,
                  inNavbar: true,
                  className: item.type === "avatar" ? "ml-lg-3" : "",
                  isOpen: dropdownOpen[item.title],
                  toggle: function toggle() {
                    return toggleDropdown(item.title);
                  },
                  children: [/*#__PURE__*/_jsx(DropdownToggle, {
                    nav: true,
                    style: item.type === "avatar" && {
                      padding: 0
                    },
                    onClick: function onClick() {
                      return setDropdownAnimate(_objectSpread(_objectSpread({}, dropdownAnimate), {}, _defineProperty({}, item.title, !dropdownOpen[item.img])));
                    },
                    children: item.type === "avatar" ? /*#__PURE__*/_jsx("div", {
                      className: "mr-2 avatar-border-white avatar avatar-sm overflow-hidden",
                      children: /*#__PURE__*/_jsx(Image, {
                        src: "/content".concat(item.img),
                        width: 36,
                        height: 36,
                        layout: "fixed",
                        alt: item.title
                      })
                    }) : item.title
                  }), /*#__PURE__*/_jsx(DropdownMenu, {
                    className: dropdownAnimate[item.title] === false ? "hide" : "",
                    right: true,
                    children: item.dropdown && item.dropdown.map(function (dropdownItem) {
                      return /*#__PURE__*/_jsx(ActiveLink, {
                        activeClassName: "active",
                        href: dropdownItem.link,
                        passHref: true,
                        children: /*#__PURE__*/_jsx(DropdownItem, {
                          onClick: function onClick() {
                            return onLinkClick(item.title);
                          },
                          children: dropdownItem.title
                        })
                      }, dropdownItem.title);
                    })
                  })]
                }, item.title);
              }), /*#__PURE__*/_jsx(FavouriteMenuItem, {}), /*#__PURE__*/_jsx(CartMenuItem, {})]
            })
          })]
        }), props.showCottageSearch && /*#__PURE__*/_jsx(Container, {
          fluid: true,
          className: "w-100",
          children: /*#__PURE__*/_jsx(SearchBar, {})
        })]
      })
    })
  });
};

export default Header;